import { useContext, useState } from "react";
import { addHoliday, deleteHoliday } from "../../../components/holidays/functions";
import { formatarData } from "../../../components/utils/functions";
import ToastContext from "../../../context/toastProvider";
import MobileFilterSheet from "../../ui/MobileFilterSheet";
import MobileFormField from "../../ui/MobileFormField";
import MobileConfirm from "../../ui/MobileConfirm";

const inputClass =
  "w-full min-h-[44px] rounded-lg border border-primary/50 bg-monao px-3 text-base text-laranjinha disabled:bg-monao";
const primaryBtn =
  "inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg bg-primary px-4 text-sm font-medium text-mgs-bg hover:bg-[#b47c06] disabled:opacity-50";
const secondaryBtn =
  "inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg border border-primary/50 px-4 text-sm font-medium text-laranjinha/80 hover:bg-monao disabled:opacity-50";
const dangerBtn =
  "inline-flex min-h-[44px] items-center justify-center rounded-lg bg-red-700 px-4 text-sm font-medium text-white hover:bg-red-800";

export function formatHolidayDateInput(value) {
  let formatted = value.replace(/\D/g, "");
  if (formatted.length > 2) {
    formatted = `${formatted.substring(0, 2)}/${formatted.substring(2)}`;
  }
  if (formatted.length > 5) {
    formatted = `${formatted.substring(0, 5)}/${formatted.substring(5)}`;
  }
  if (formatted.length <= 10) {
    return formatted;
  }
  return formatted.substring(0, 10);
}

export function parseFormattedHolidayDate(value) {
  const [day, month, year] = value.split("/");
  return new Date(Number(year), Number(month) - 1, Number(day));
}

export function MobileCreateHolidaySheet({ open, onClose, user, onCreated }) {
  const { goodToast, badToast } = useContext(ToastContext);

  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setName("");
    setDate("");
    setLoading(false);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    if (!name.trim()) {
      badToast("Insira um nome");
      return;
    }
    if (!date.trim()) {
      badToast("Insira uma data");
      return;
    }

    setLoading(true);
    const data = await addHoliday(user.token, {
      name: name.trim(),
      date: parseFormattedHolidayDate(date),
    });
    setLoading(false);

    if (data.type === "success") {
      goodToast("Novo feriado cadastrado!");
      resetForm();
      onCreated();
    }
    if (data.type === "error") {
      badToast(data.message ?? "Erro ao cadastrar feriado");
    }
  };

  if (!open) return null;

  return (
    <MobileFilterSheet open={open} onClose={handleClose} title="Cadastrar feriado">
      <div className="space-y-4">
        <MobileFormField label="Nome">
          <input
            type="text"
            aria-label="Nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={inputClass}
          />
        </MobileFormField>
        <MobileFormField label="Data">
          <input
            type="text"
            aria-label="Data"
            placeholder="DD/MM/AAAA"
            value={date}
            onChange={(e) => setDate(formatHolidayDateInput(e.target.value))}
            className={inputClass}
          />
        </MobileFormField>
        <div className="flex gap-3">
          <button type="button" onClick={handleClose} className={secondaryBtn}>
            Cancelar
          </button>
          <button type="button" onClick={handleSubmit} disabled={loading} className={primaryBtn}>
            Criar
          </button>
        </div>
      </div>
    </MobileFilterSheet>
  );
}

export function MobileHolidayDetailSheet({ open, onClose, holiday, user, onChanged }) {
  const { goodToast, badToast } = useContext(ToastContext);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setConfirmOpen(false);
    onClose();
  };

  const handleDelete = async () => {
    setLoading(true);
    const data = await deleteHoliday(user.token, holiday._id);
    setLoading(false);
    setConfirmOpen(false);

    if (data.type === "success") {
      goodToast("Feriado excluído");
      onChanged();
    }
    if (data.type === "error") {
      badToast(data.message ?? "Erro ao excluir feriado");
    }
  };

  if (!open || !holiday) return null;

  return (
    <>
      <MobileFilterSheet open={open} onClose={handleClose} title="Detalhe do feriado">
        <div className="space-y-4">
          <MobileFormField label="Nome">
            <input
              type="text"
              value={holiday.name ?? ""}
              disabled
              className={inputClass}
              aria-label="Nome"
            />
          </MobileFormField>
          <MobileFormField label="Data">
            <input
              type="text"
              value={formatarData(holiday.date) ?? ""}
              disabled
              className={inputClass}
              aria-label="Data"
            />
          </MobileFormField>
          <button
            type="button"
            onClick={() => setConfirmOpen(true)}
            disabled={loading}
            className={dangerBtn}
          >
            Excluir
          </button>
        </div>
      </MobileFilterSheet>

      <MobileConfirm
        open={confirmOpen}
        title="Excluir feriado"
        message={`Confirma a exclusão de "${holiday.name}"?`}
        onConfirm={handleDelete}
        onCancel={() => setConfirmOpen(false)}
      />
    </>
  );
}
